import { FC } from 'react';
// components
import VeganTypeRadioGroup from 'components/main/Formulas/Dosage/Add/components/VeganTypeRadioGroup';

const PrePost: FC = () => <VeganTypeRadioGroup />;

export default PrePost;
